import styled from 'styled-components';

export const BannerLink = styled.a`
  display: block;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;
